import { render } from "./MainMenuView.vue?vue&type=template&id=2fda2d4c&scoped=true"
import script from "./MainMenuView.vue?vue&type=script&lang=js"
export * from "./MainMenuView.vue?vue&type=script&lang=js"

import "./MainMenuView.vue?vue&type=style&index=0&id=2fda2d4c&scoped=true&lang=css"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fda2d4c"]])

export default __exports__